import { FormattedDate } from '@common/components/FormattedDate';
import { NavigationTabsOption } from '@common/types/link';
import { Collection, useCollections } from '@features/Collection';
import { TableCard } from '@features/tableEngine/components';
import { ColumnDef } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CollectionTitleCell } from './CollectionTitleCell';

interface CollectionSearchProps {
    tabOptions: NavigationTabsOption<string>[];
}

const PAGE_SIZES = [...Array(5)].map((_, i) => (i + 1) * 25);

export const CollectionSearchView = ({ tabOptions }: CollectionSearchProps) => {
    const { t } = useTranslation('advancedSearch');

    const result = useCollections({ pageSize: PAGE_SIZES[0] });

    const columns: ColumnDef<Collection>[] = useMemo(
        () => [
            {
                accessorKey: 'id',
                header: t('table.header.collection.id'),
                size: 60,
                minSize: 60,
                maxSize: 60,
                enableResizing: false,
                meta: {
                    defaultHidden: true,
                },
            },
            {
                accessorKey: 'title',
                header: t('table.header.collection.title'),
                cell: ({ row: { original } }) => (
                    <CollectionTitleCell collection={original} />
                ),
                size: 250,
            },
            {
                accessorKey: 'created',
                header: t('table.header.collection.created'),
                cell: ({ cell }) => {
                    const date = cell.getValue() as number;
                    return <FormattedDate date={date} />;
                },
            },
            {
                accessorKey: 'updated',
                header: t('table.header.collection.updated'),
                cell: ({ cell }) => {
                    const date = cell.getValue() as number;
                    return <FormattedDate date={date} />;
                },
            },
        ],
        [t],
    );

    return (
        <TableCard<Collection>
            size={'1'}
            {...result}
            // tabState={tabState}
            tabOptions={tabOptions}
            config={{
                search: { enabled: true, placeholder: t('search.placeholder') },
                selection: { enabled: true, displayKey: 'title' },
                sorting: { enabled: true },
                columnControl: { enabled: true },
                pagination: { enabled: true, pageSizes: PAGE_SIZES },
                columns,
            }}
            maxRows={'unlimited'}
        />
    );
};
